import React from 'react'
import {Link, useNavigate} from "react-router-dom";
import Sidebar from "../../../../components/Sidebar";
import PageHeader from "../../../../components/PageHeader";
import {toast} from "react-toastify";
import DatePicker, {registerLocale} from "react-datepicker";
import {getSchoolId, getSchoolYear} from "../../../../utils/authority";
import ClassRoomController from "../../../../services/data-declaration/class-room-controller";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import vi from "date-fns/locale/vi";
import FilesApi from "../../../../services/resource/files-api";
import Dropzone from "react-dropzone";
import NewsController from "../../../../services/system/news/news-controller";
registerLocale("vi", vi);
function withRouter(Component) {
    return (props) => <Component {...props} navigate={useNavigate()} />;
}
function uploadAdapter(loader) {
    return {
        upload: () => {
            return new Promise((resolve, reject) => {
                FilesApi.uploadFileCkeditor( loader, res => {
                    if (res.success) {
                        resolve({
                            default: res.data.url
                        });
                    }else {
                        reject(res.error);
                    }
                })
            })
        }
    }
}
function uploadPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
        return uploadAdapter(loader);
    };
}
class CreateNewsManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            shortDescription: "",
            image: "",
            imgFile: "",
            title: "",
            yearId: parseInt(getSchoolYear()),
            state: "ACTIVE",
            type: "NEWS",
            content: "",
            files: [],
        };
    }

    saveContent(newContent) {
        this.setState({
            content: newContent,
        });
    }
    renderStatus() {
        let listStatus = [
            {
                "id": "ACTIVE",
                "name": "Hoạt động"
            },
            {
                "id": "INACTIVE",
                "name": "Khóa"
            }
        ]
        return listStatus.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    onCreate = () => {
        let {title} = this.state;
        if (title == "" || title.length < 5){
            toast.error("Tiêu đề tin tức phải lớn hơn 5 ký tự");
        }else if(this.state.content == ""){
            toast.error("Vui lòng nhập nội dung tin tức");
        }else {
            let payload = {
                "content": this.state.content,
                "image": this.state.image,
                "shortDescription": this.state.shortDescription,
                "state": this.state.state,
                "type": this.state.type,
                "title": this.state.title,
            }
            console.log(payload)
            NewsController.create(payload, res => {
                if (res.success){
                    this.props.navigate('/ad-sas-school/quan-ly-tin-tuc');
                    toast.success("Tạo tin tuc thành công!")
                } else {
                    toast.error("Đã xảy ra lỗi! " + res.message)
                }
            })
        }
    }
    onFileChange = () => {
        let payload = {
            file: this.state.files,
        }
        FilesApi.uploadFile(payload, res => {
            if (res.success) {
                this.setState({
                    url: res.data.url,
                }, () => {
                    toast.success('Upload thành công!')
                })
            }
        }).catch(error => console.log("upload error>>>", error))
    };
    onUpImage = () => {
        let payload = {
            file: this.state.files,
        }
        FilesApi.uploadFile(payload, res => {
            if (res.success) {
                this.setState({
                    image: res.data.url,
                }, () => {
                    toast.success('Tải ảnh thành công!')
                    this.showImage()
                })
            }
        }).catch(error => console.log("upload error>>>", error))
    };
    showImage(){
        if (this.state.image.length > 0){
            FilesApi.showFile(this.state.image, res=>{
                this.setState({
                    imgFile: res
                })
            })
        }
    }
    render() {
        const files = this.state.files.map(file => (
            <li key={file.name}>
                {file.name}-{file.size} bytes
            </li>
        ));
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="news-management"/>
                        <div className="mb-4 col-md-10 tab-content">
                            <div className="card col-12">
                                <div className='pt-3 mb-2'>
                                    <PageHeader routerEnable={true} title="Thêm mới thông báo"/>
                                    <div className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <h2 className='text-center mb-4'>THÊM MỚI TIN TỨC</h2>
                                        <div className="row">
                                            <div className="col-md-12 col-xs-12 d-flex mb-2">
                                                <label className="col-md-2 col-xs-12 label-item pl-0">Tiêu đề tin tức<span  style={{color: "red",}}>*</span></label>
                                                <input
                                                    placeholder="Nhập tiêu đề tin tức"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.title}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            title: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-12 col-xs-12 d-flex mb-2">
                                                <label className="col-md-2 col-xs-12 label-item pl-0">Mô tả ngắn</label>
                                                <input
                                                    placeholder="Nhập mô tả nội dung"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.shortDescription}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            shortDescription: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-12 col-xs-12 d-flex mb-2">
                                                <label className="col-md-2 label-item pl-0">Ảnh</label>
                                                <Dropzone accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, text/csv, video/mp4, audio/mpeg, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, text/plain, application/vnd.ms-excel
, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/zip, application/x-7z-compressed"
                                                          onDrop={acceptedFiles => {
                                                              this.setState({files: acceptedFiles}, () =>{
                                                                  this.onUpImage()
                                                              })
                                                          }}
                                                          multiple={false}>
                                                    {({getRootProps, getInputProps}) => (
                                                        <section className="container-upload col-md-10">
                                                            <div {...getRootProps({className: 'dropzone'})}>
                                                                <img width="200px" key={this.state.imgFile} src={this.state.imgFile} />
                                                                <input {...getInputProps()} />
                                                                {files.length > 0 ? <div className="align-center">
                                                                    <ul>{files}</ul>
                                                                </div> : <p>Chọn tập tin để upload</p>}
                                                            </div>
                                                        </section>
                                                    )}
                                                </Dropzone>
                                            </div>
                                            <div className="col-md-12 col-xs-12 p-1 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Nội dung thông báo<span  style={{color: "red",}}>*</span></label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-1 pr-md-3 d-flex">
                                                {/*https://www.techgalery.com/2021/05/how-to-use-react-ckeditor-upload-file.html*/}
                                                <CKEditor
                                                    config={{
                                                        extraPlugins: [uploadPlugin]
                                                    }}
                                                    editor={ ClassicEditor }
                                                    data=""
                                                    onReady={ editor => {
                                                        // You can store the "editor" and use when it is needed.
                                                        // console.log( 'Editor is ready to use!', editor );
                                                    } }
                                                    onChange={ ( event, editor ) => {
                                                        const data = editor.getData();
                                                        this.saveContent(data)
                                                        // console.log( { event, editor, data } );
                                                    } }
                                                />
                                            </div>


                                            <div className="col-md-6 col-xs-12 d-flex mt-2">
                                                <label className="label-item col-md-4">Loại tin tức</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.type}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            type: e.target.value
                                                        })
                                                    }}
                                                >
                                                    <option value="NEWS">Tin tức nhà trường</option>
                                                    <option value="BANNER">Banner quảng cáo</option>
                                                </select>
                                            </div>
                                            <div className="col-md-6 col-xs-12 d-flex mt-2">
                                                <label className="label-item col-md-4">Trạng thái</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.state}
                                                    onChange={(e) => {
                                                        this.state.state = e.target.value;
                                                        this.setState({
                                                            state: e.target.value
                                                        })
                                                    }}
                                                >
                                                    {this.renderStatus()}
                                                </select>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="align-right col-12">
                                    <div className="d-flex justify-content-center align-center mt-3 mb-2">
                                        <button
                                            type="button"
                                            className="ml-4 border-1-s background-btn type-button-fix btn btn-primary shadow-none"
                                            disabled={this.state.title == ""}
                                            onClick={()=> {
                                                this.onCreate()
                                            }}
                                        >
                                            Lưu
                                        </button>
                                        <button
                                            type="button"
                                            className="ml-4 border-1-s type-button-fix btn btn-light shadow-none"
                                        >
                                            <Link
                                                style={{color: '#000'}}
                                                to={{
                                                    pathname: "/ad-sas-school/quan-ly-thong-bao"
                                                }}
                                            >
                                                Hủy bỏ
                                            </Link>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(CreateNewsManagement)
